<div class="container-fluid px-0 py-3">
    <div>
        <div class="text-center">
            <div class="titre">{{'Produits associés'|uppercase}}</div>
        </div>

        <app-carousel [elements]="products" [display]="enum" [champs]="champs"></app-carousel>
    </div>
</div>